exports.wrapperGetLogoUrlInApp = function () {
  return getLogoUrlInApp();
}

//updateUserUI
exports.wrapperUpdateUserUI = function () {
  return updateUserUI();
}

//getSiteLanguage
exports.wrapperGetSiteLanguage = function () {
  return getSiteLanguage();
}
//getSiteVersion
exports.wrapperGetSiteVersion = function () {
  return getSiteVersion();
}
//getSiteLogo
exports.wrapperGetSiteLogo = function () {
  return getSiteLogo();
}

exports.wrapperRequestNativeLogin = function (callback) {
  return requestNativeLogin(callback);
}

//registerWebhookCallback
exports.wrapperRegisterWebhookCallback = function (callback) {
  return registerWebhookCallback(callback);
}

function registerWebhookCallback(callback) {
  popupWebhookCallback = callback;
}

//registerCloseCallback
exports.wrapperRegisterCloseCallback = function (callback) {
  return registerCloseCallback(callback);
}

function registerCloseCallback(callback) {
  popupCloseCallback = callback;
}

exports.wrapperSwitchServerSessionStorageParams = function (baseHrefForServerParm) {
  return switchServerSessionStorageParams(baseHrefForServerParm);
}

exports.wrapperGetBaseHrefForServer = function (serverId) {
  return getBaseHrefForServer(serverId);
}

exports.wrapperGetSiteLanguage = function () {
  return getSiteLanguage();
}

exports.wrapperGetSiteVersion = function () {
  return getSiteVersion();
}

exports.wrapperGetSiteLogo = function () {
  return getSiteLogo();
}

exports.wrapperGetNativeLogin = function () {
  return getNativeLogin();
}

exports.wrapperUseDynamicDNSSupport = function () {  
  return useDynamicDNSSupport();
}

exports.wrapperSetServerSessionStorageParams = function (url) {
  return setServerSessionStorageParams(url);
}
exports.wrapperupdateUserUI = function () {
  return updateUserUI();
}
exports.wrapperGetServerId = function () {
  return getServerId();
}
//exports.wrapperGetBaseHrefForServer = function () {
//  return getBaseHrefForServer();
//}
exports.wrappergetAppLoginUrl = function () {
  return getAppLoginUrl();
}

// fastspring
exports.wrapperFastspring = fastspring; 

//gtag
exports.wrapperGtag = gtag;

exports.wrappergDriveTokenClient = gDriveTokenClient;

exports.wrapperGetgDriveAccessToken = function () {
  return getGDriveAccessToken();
}

exports.wrapperSetGDriveAccessToken = function (gDriveAccessTokenValue) {
  return setGDriveAccessToken(gDriveAccessTokenValue);
}

exports.wrappergoToMyAccountNow = function () {
  return goToMyAccountNow();
}

exports.wrapperGetCalledFromClientApi = function () {
  return getCalledFromClientApi();
}
